<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive">
      </router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import { onMounted } from 'vue'
export default {
  name: 'App',
  data() {
    return {
      viewWidth: window.innerWidth,
    }
  },
  mounted() {
    if (this.viewWidth >= 854) {
      let locale = 'en';
      let temp = locale === 'en' ? 'en' : 'zh';
      this.$i18n.locale = temp;//改变当前语言
    } else {
      this.$i18n.locale = 'en'
    }
  },
}

</script>


<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

ul,
ol {
  list-style: none;
}

a {
  text-decoration: none;
}

html,
body {
  font-family: Arial, Helvetica, sans-serif;
}

#app {
  width: 100%;
  height: 100%;
  background: #F7F7F7;
  color: #1a1a1a;
}
</style>



// WEBPACK FOOTER //
// src/App.vue